
import { withCompController } from '@wix/editor-elements-integrations';
import type {
  ISimpleCardProps,
  ISimpleCardMapperProps,
  ISimpleCardControllerProps,
  ISimpleCardStateValues,
} from '../../../components/SimpleCard/SimpleCard.props';

export default withCompController<
  ISimpleCardMapperProps,
  ISimpleCardControllerProps,
  ISimpleCardProps,
  ISimpleCardStateValues
>(({ mapperProps, controllerUtils, stateValues }) => {
  const { editorType } = stateValues
  return {
    ...mapperProps,
    editorType,
    updateComponentPropsInViewer: props => {
      controllerUtils.updateProps(props);
    }
  }
});
